import { Injectable, Component } from '@angular/core';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

    constructor(
    ) { }

    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        XLSX.writeFile(workbook, excelFileName + "_" + moment(new Date()).format("MMMM DD YYYY,hh:mm:ss a") + EXCEL_EXTENSION);
    }


}


// WEBPACK FOOTER //
// ./src/app/_services/export-excel/export-excel.service.ts